// extracted by mini-css-extract-plugin
module.exports = {"positionedElement":"ensure-inside-container_positionedElement_3N0"};